import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import { showNotification } from "Helpers/Toast";

import UseAuth from "Hooks/UseAuth";
import UseServices from "Hooks/UseServices";

import Button from "Components/Global/Buttons";

import Question from "./Components/Question";
import * as S from "./styles";

const Questions = ({ projectId }) => {
  const { api } = UseServices();
  const { parsedJWT } = UseAuth();

  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    return getProjectQuestions(projectId);

    // eslint-disable-next-line
  }, []);

  const getProjectQuestions = (project_id) => {
    api
      .post("/project-questions/get-project-questions-by-project-id", {
        project_id: project_id,
      })
      .then((response) => {
        const questions = response.data?.project_questions;

        setQuestions(questions);

        for (const question of questions) {
          if (!question.answers || !question.answers.length) continue;

          const is_text_answer = question.type === "text";

          if (is_text_answer) {
            setAnswers((prev) => ({
              ...prev,
              [question.id]: question?.answers[0]?.text,
            }));
            continue;
          }

          setAnswers((prev) => ({
            ...prev,
            [question.id]: question.answers.map(
              (answer) => answer?.question_option_id,
            ),
          }));
        }
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const answerQuestions = () => {
    if (Object.keys(answers).length === 0) return;
    if (Object.keys(answers).length !== questions.length)
      return showNotification(
        "danger",
        "Atenção",
        "Por favor, responda todas as perguntas!",
      );

    for (const question of questions) {
      if (!answers[question.id]) continue;

      if (Array.isArray(answers[question.id])) {
        if (answers[question.id].length === 0)
          return showNotification(
            "danger",
            "Atenção",
            "Por favor, responda todas as opções!",
          );
      }
    }

    api
      .post("/project-questions/answer-project-questions", {
        answers,
      })
      .then(() => {
        showNotification(
          "success",
          "Sucesso!",
          "Peguntas respondidas com sucesso!",
        );

        getProjectQuestions(projectId);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const isSponsor = parsedJWT?.user?.is_sponsor;

  return (
    <S.Wrapper>
      <S.Section>
        <span>Perguntas</span>
        <hr />
      </S.Section>

      {!questions.length ? (
        <span>Nenhuma pergunta cadastrada.</span>
      ) : (
        <Form onSubmit={answerQuestions}>
          {questions.map((question) => (
            <Question
              key={question.id}
              question={question}
              answers={answers[question.id]}
              setAnswers={setAnswers}
              isSponsor={isSponsor}
            />
          ))}

          <S.Buttons>
            <div />

            <Button type="submit" text="Responder" disabled={isSponsor} />
          </S.Buttons>
        </Form>
      )}
    </S.Wrapper>
  );
};

export default Questions;
